import { createContext, useContext } from 'react';
const defaultContextValue = false;
export const DialogSurfaceContext = createContext(undefined);
export const DialogSurfaceProvider = DialogSurfaceContext.Provider;
export const useDialogSurfaceContext_unstable = ()=>{
    var _useContext;
    return (_useContext = useContext(DialogSurfaceContext)) !== null && _useContext !== void 0 ? _useContext : defaultContextValue;
};
